export default __webpack_public_path__ + "static/danialprofile-53ac88067b0ccc4229d75a97744399dd.png";